import type { Glyph } from "./types";

export const CheckIcon: Glyph = (props) => (
  <svg viewBox="0 0 50 50" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M48.065 9.707C48.412 9.351 48.982 9.343 49.338 9.69C49.694 10.037 49.701 10.607 49.354 10.963L18.993 42.101L2.348 24.666C2.006 24.306 2.019 23.736 2.379 23.393C2.738 23.051 3.308 23.064 3.651 23.424L19.007 39.508L48.065 9.707Z" />
  </svg>
);

export default CheckIcon;
